import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16 32C7.17913 32 0 24.8209 0 16C0 7.17913 7.17913 0 16 0C24.8209 0 32 7.17913 32 16C32 24.8209 24.8209 32 16 32ZM16 1.3913C7.94435 1.3913 1.3913 7.94435 1.3913 16C1.3913 24.0557 7.94435 30.6087 16 30.6087C24.0557 30.6087 30.6087 24.0557 30.6087 16C30.6087 7.94435 24.0557 1.3913 16 1.3913Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.3483 25.0433C23.9588 25.0433 23.6527 24.7372 23.6527 24.3477C23.6527 20.132 20.2162 16.6955 16.0005 16.6955C11.7849 16.6955 8.34834 20.132 8.34834 24.3477C8.34834 24.7372 8.04225 25.0433 7.65268 25.0433C7.26312 25.0433 6.95703 24.7372 6.95703 24.3477C6.95703 19.3668 11.0196 15.3042 16.0005 15.3042C20.9814 15.3042 25.044 19.3668 25.044 24.3477C25.044 24.7372 24.7379 25.0433 24.3483 25.0433Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.0004 13.913C13.3152 13.913 11.1309 11.7286 11.1309 9.04339C11.1309 6.35818 13.3152 4.17383 16.0004 4.17383C18.6856 4.17383 20.87 6.35818 20.87 9.04339C20.87 11.7286 18.6856 13.913 16.0004 13.913ZM16.0004 5.56513C14.0804 5.56513 12.5222 7.12339 12.5222 9.04339C12.5222 10.9634 14.0804 12.5217 16.0004 12.5217C17.9204 12.5217 19.4787 10.9634 19.4787 9.04339C19.4787 7.12339 17.9204 5.56513 16.0004 5.56513Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }